import { WMSUploadDocument } from "./interfaces"

export const toJobTitlesData = (data: any) => ({
  storeType: data.storeType,
  jobTitles: data.jobTitles.map((item: string) => ({
    label: item,
    value: item
  }))
})

export const toDocumentsUploadPayload = (documents: WMSUploadDocument[]): FormData => {
  let index = 1
  return documents.reduce((acc, doc) => {
    doc.images.forEach((image: File) => {
      let name = image.name
      if (doc.documentType.multiselect) {
        name = `${index}_${image.name}`
      }
      const newImage = new File([image], name, { type: image.type })
      acc.append(doc.documentType.value, newImage)
    })

    if (doc.documentType.multiselect) {
      index++
    }

    return acc
  }, new FormData())
}
